__webpack_require__.p = "https://app.theyellowhub.org/";